import { LawWorksChargesPage } from "@/components/features/lawworks-charges/LawWorksChargesPage";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/charges")({
  component: RouteComponent,
});

function RouteComponent() {
  const { currentUser } = useUser();

  if (!currentUser.owner) {
    return <GlobalNotAuthorized />;
  }

  return <LawWorksChargesPage />;
}
